import React from 'react';
import styles from './ProgressCircle.module.scss';

class ProgressCircle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // Size of the enclosing square
    const sqSize = this.props.sqSize;
    // SVG centers the stroke width on the radius, subtract out so circle fits in square
    const radius = (this.props.sqSize - this.props.strokeWidth) / 2;
    // Enclose cicle in a circumscribing square
    const viewBox = `0 0 ${sqSize} ${sqSize}`;
    // Arc length at 100% coverage is the circle circumference
    const dashArray = radius * Math.PI * 2;
    // Scale 100% coverage overlay with the actual percent
    const dashOffset = dashArray - (dashArray * this.props.percentage) / 100;

    return (
      <div className={styles.progressBarContainer}>
        <svg width={this.props.sqSize} height={this.props.sqSize} viewBox={viewBox}>
          <circle
            className={styles.circle_background}
            cx={this.props.sqSize / 2}
            cy={this.props.sqSize / 2}
            r={radius}
            strokeWidth={`${this.props.strokeWidth}px`}
          />
          <circle
            className={styles.circle_progress}
            cx={this.props.sqSize / 2}
            cy={this.props.sqSize / 2}
            r={radius}
            strokeWidth={`${this.props.strokeWidth}px`}
            // Start progress marker at 12 O'Clock
            transform={`rotate(-90 ${this.props.sqSize / 2} ${this.props.sqSize / 2})`}
            style={{
              strokeDasharray: dashArray,
              strokeDashoffset: isNaN(dashOffset) ? 0 : dashOffset,
            }}
          />
        </svg>
        {this.props.percentage === 100 ? (
          <svg
            width="15"
            height="10"
            viewBox="0 0 15 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.downloadFinished}
          >
            <path d="M1 4.2L5.875 9L14 1" stroke="#37C1A0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : (
          <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.downloadArrow}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6 0C6.55228 0 7 0.447715 7 1V10C7 10.5523 6.55228 11 6 11C5.44772 11 5 10.5523 5 10V1C5 0.447715 5.44772 0 6 0Z"
              fill="#37C1A0"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.29289 5.29289C1.68342 4.90237 2.31658 4.90237 2.70711 5.29289L6 8.58579L9.29289 5.29289C9.68342 4.90237 10.3166 4.90237 10.7071 5.29289C11.0976 5.68342 11.0976 6.31658 10.7071 6.70711L6.70711 10.7071C6.31658 11.0976 5.68342 11.0976 5.29289 10.7071L1.29289 6.70711C0.902369 6.31658 0.902369 5.68342 1.29289 5.29289Z"
              fill="#37C1A0"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 13C0 12.4477 0.447715 12 1 12H11C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14H1C0.447715 14 0 13.5523 0 13Z"
              fill="#37C1A0"
            />
          </svg>
        )}
      </div>
    );
  }
}

ProgressCircle.defaultProps = {
  sqSize: 200,
  percentage: 0,
  strokeWidth: 10,
};

export default ProgressCircle;
